import { render, staticRenderFns } from "./ResumoContratual.vue?vue&type=template&id=0a599bde&scoped=true&"
import script from "./ResumoContratual.vue?vue&type=script&lang=js&"
export * from "./ResumoContratual.vue?vue&type=script&lang=js&"
import style0 from "./ResumoContratual.vue?vue&type=style&index=0&id=0a599bde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a599bde",
  null
  
)

export default component.exports